import type { MouseEventHandler } from 'react';
import type { ModalData, SelectOption } from '..';

export interface ModalAddLanguageValues {
  language?: string;
}

export interface ModalAddLanguageOptions {
  languages: SelectOption<string>[];
}

export interface ModalAddLanguageData {
  modal: ModalData;
  form: {
    initialValues: ModalAddLanguageValues;
    onSubmit: (values: ModalAddLanguageValues) => void;
    options: ModalAddLanguageOptions;
  };
  onCancelClick?: MouseEventHandler;
}

export interface ModalAddLanguageProps extends ModalAddLanguageData {}
